import React, { useEffect } from 'react';

const Dmca = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Scroll to the top smoothly when the FeedBack component mounts
    });
  }, []);
  return (
    <div>
      <div className="flex justify-center items-center mb-32">
        <div className="shadow-lg bg-slate-50 justify-between items-stretch max-w-[1170px] rounded-xl mt-40 flex w-full gap-5 px-10 py-9 max-md:max-w-full max-md:flex-wrap max-md:px-5">
          <div className="flex flex-col items-stretch max-md:max-w-full">
            <div className="text-slate-500 text-lg leading-5 max-md:max-w-full">Claims of Copyright Infringement & Related Issues (17 USC § 512 et seq.).</div>
            <div>
              <p className="mt-5 leading-6">We respect the intellectual property rights of others. Anyone who believes their work has been reproduced in a way that constitutes copyright infringement may notify our agent by providing the following information:</p>

              <ul className="list-[lower-alpha] mt-6 md:ml-8">
                <li className="mt-3">Identification of the copyrighted work that you claim has been infringed, or, if multiple copyrighted works at a single online site are covered by a single notification, a representative list of such works at the site;</li>
                <li className="mt-3">Identification of the material that you claim is infringing and needs to be removed, including a description of where it is located so that the copyright agent can locate it</li>
                <li className="mt-3">Your address, telephone number, and, if available, e-mail address, so that the copyright agent may contact you about your complaint, and</li>
                <li className="mt-3">A signed statement that the above information is accurate; that you have a good faith belief that the identified use of the material is not authorized by the copyright owner, its agent, or the law; and, under penalty of perjury, that you are the copyright owner or are authorized to act on the copyright owner's behalf in this situation.</li>
              </ul>
              <p className="mt-2">Upon obtaining such knowledge we will act expeditiously to remove, or disable access to, the material. Please be aware that there are substantial penalties for false claims.</p>

              <p className="mt-8">If a notice of copyright infringement has been wrongly filed against you, you may submit a counter notification to our agent. A valid counter notification is a written communication that incorporates the following elements:</p>

              <ul className="list-[lower-alpha] mt-6 md:ml-8">
                <li className="mt-3">A physical or electronic signature of the poster</li>
                <li className="mt-3">Identification of the material that has been removed or to which access has been disabled and the location at which the material appeared before it was removed or access to it was disabled</li>
                <li className="mt-3">A statement under penalty of perjury that you have a good faith belief that the material was removed or disabled as a result of mistake or misidentification</li>
                <li className="mt-3">Your name, address, and telephone number; a statement that you consent to the jurisdiction of federal district court for the judicial district in which your address is located, or if your address is outside of the U.S., for any judicial district in which the service provider may be found; and that you will accept service of process from the complainant.</li>
              </ul>

              <p className="mt-8 mb-2">Notices of the foregoing copyright issues should be sent as follows:</p>
              {/* <p className="font-semibold">By mail:</p>
              <p>John L. Scott, Inc</p>
              <p>Legal Dept.</p>
              <p>11040 Main St. #280</p>
              <p>Attn: Legal Dept.</p>
              <p>Bellevue, WA 98004</p> */}

              <h3 className="mt-5 font-semibold">By e-mail:</h3>
              <a href="mailto:boneymathew@dreamvisionhomes.com" className="mt-2 text-blue-900 font-semibold">
              boneymathew@dreamvisionhomes.com
              </a>
              <p className="mt-6">If you give notice of copyright infringement by e-mail, an agent may begin investigating the alleged copyright infringement; however, we must receive your signed statement by mail or as an attachment to your e-mail before we are required to take any action.</p>
              <p className="mt-6">
                This information should not be construed as legal advice. We recommend you seek independent legal counsel before filing a notification or counter-notification. For further information about the DMCA, please visit the website of the United States Copyright Office at:{' '}
                <a href="http://www.copyright.gov/onlinesp" className="mt-2 text-blue-900 font-semibold" target="_blank" rel="noreferrer">
                  http://www.copyright.gov/onlinesp
                </a>
                .
              </p>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dmca;
